import React, { Component, createRef } from 'react';
import {
    Container,
    Button,
    Row,
    Col,
    Form,
    FormGroup,
    Input,
    Label
} from 'reactstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCheck } from '@fortawesome/free-solid-svg-icons'
import CollapseCard from '../CollapseCard/CollapseCard';
import JoditEditor from 'jodit-react';
import * as utilities from '../../utilities';
import CompanyContext from '../../auth/CompanyContext';
import { Prompt } from 'react-router-dom';


class MyProfile extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.editor = createRef();
        this.state = {
            firstName: this.props.userData['First Name'] || '',
            lastName: this.props.userData['Last Name'] || '',
            title: this.props.userData.Title || '',
            customEmail: this.props.userData['CustomEmail'] || this.props.userData['Email Address'] || '',
            workflowOutlookInDays: this.props.userData['WorkflowOutlookInDays'] || 3,
            unsavedChanges: false
        }

        this.config = {
            readonly: false, // Enable editing
            height: 400,
            enter: "BR",
            toolbarAdaptive: false, // Keep toolbar visible
            enterBlock: "div", // Default block element is <div> instead of <p>
            blockTags: ["div"],
            hidePoweredByJodit: true,
            showWordsCounter: false,
            showCharsCounter: false,
            allowResizeX: false,
            allowResizeY: false,
            showXPathInStatusbar: false,
            link: {
                noFollowCheckbox: false,
                openInNewTabCheckbox: false,
                processPastedLink: true
            },
            buttons: [
                "bold", "italic", "underline", "eraser", // Text formatting + clear formatting
                "|", // Separator
                "ul", "ol", // Bullet & number lists
                "|",
                "font", "fontsize", // Font family & size
                "|",
                "image", "link", // Insert image & link
                "|",
                "hr", // Insert divider & special character
                "|",
                "align", "brush", // Text alignment & color
                "|",
                "source" // Change mode (HTML mode toggle)
            ]
        };
    }

    componentDidMount() {
        // this.getLinks();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    onChange = (e) => {
        console.log(e.target)
        e.persist();
        this.setState({
            [e.target.name]: e.target.value,
            unsavedChanges: true
        });
        // if (this.editor.current) {
        //     const htmlContent = this.editor.current.value; // Get the editor's HTML content
        //     const plainText = htmlContent.replace(/<\/?[^>]+(>|$)/g, ""); // Strip HTML tags
        //     this.setState({ plainText }); // Update plain text without affecting the editor
        // }
    }

    handleEdit = () => {
        fetch('/api/users/' + this.props.user, {
            method: 'PUT',
            body: JSON.stringify({
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                title: this.state.title,
                customEmail: this.state.customEmail,
                workflowOutlookInDays: this.state.workflowOutlookInDays,
                signature: this.editor.current.value
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.refreshUser();
                    this.setState({
                        unsavedChanges: false
                    })
                    utilities.addToast('Signature saved.', 5, 'success');
                } else {
                    utilities.addToast('Unable to save signature.', 5, 'danger');
                }
            })
            .catch(() => {
                utilities.addToast('An error has occurred.', 5, 'danger');
            })
    }


    render() {

        return (
            <Container fluid>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                <CollapseCard title="Email Signature and Profile Info" open={true} header="h3">
                    <Row className="py-4 text-left align-items-bottom">
                        <Col md={6}>
                            <Label>Email Signature Text
                                <JoditEditor
                                    ref={this.editor}
                                    config={this.config}
                                    value={this.props.userData?.Signature}
                                />
                            </Label>
                        </Col>
                        <Col>
                            <Form >
                                <FormGroup>
                                    <Label>First Name
                                        <Input
                                            placeholder="First Name"
                                            name="firstName"
                                            value={this.state.firstName}
                                            onChange={this.onChange} />
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Last Name
                                        <Input
                                            placeholder="Last Name"
                                            name="lastName"
                                            value={this.state.lastName}
                                            onChange={this.onChange} />
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Title
                                        <Input
                                            placeholder="Title"
                                            name="title"
                                            value={this.state.title}
                                            onChange={this.onChange} />
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Email Address
                                        <Input
                                            placeholder="Email Address"
                                            name="customEmail"
                                            value={this.state.customEmail}
                                            onChange={this.onChange} />
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Home - Upcoming Workflow Tasks Visibility Window
                                        <Input
                                            type="select"
                                            name="workflowOutlookInDays"
                                            value={this.state.workflowOutlookInDays}
                                            onChange={this.onChange} >
                                            {/* <option value="">SELECT</option> */}
                                            <option value="1">1 Day</option>
                                            <option value="2">2 Days</option>
                                            <option value="3">3 Days</option>
                                            <option value="4">4 Days</option>
                                            <option value="5">5 Days</option>
                                            <option value="7">1 Week</option>
                                            <option value="14">2 Weeks</option>
                                            <option value="30">1 Month</option>
                                            <option value="90">3 Months</option>
                                            <option value="180">6 Months</option>
                                            <option value="10000000">Show All</option>
                                        </Input>
                                    </Label>
                                </FormGroup>
                            </Form>
                            <Row className="pt-5 mt-5 text-right align-items-bottom">
                                <Col>
                                    <Button
                                        color="success"
                                        onClick={this.handleEdit}
                                        disabled={!this.state.unsavedChanges}
                                    >
                                        {/* <FontAwesomeIcon icon={faCheck} />  */}
                                        Save Changes
                                    </Button>
                                </Col>
                            </Row>
                        </Col>

                    </Row>

                </CollapseCard>
            </Container>
        );
    }
}

export default MyProfile;
